// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__38Bzq","alert":"SettungsInbox_alert__2x1cq"};